import { render, staticRenderFns } from "./ImageEffectsPropertiesCreateHeader.vue?vue&type=template&id=0d4fe8b7&scoped=true"
import script from "./ImageEffectsPropertiesCreateHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsPropertiesCreateHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageEffectsPropertiesCreateHeader.vue?vue&type=style&index=0&id=0d4fe8b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4fe8b7",
  null
  
)

export default component.exports